import styled from "styled-components";

export const Container = styled.div`
  .isOpen {
    max-height: 9999px;
    transition: max-height 4s;
    opacity: 1;
  }
`;
